import * as React from 'react';
import { FC } from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useStore } from 'features/store/hooks/use-store';
import { Linking, StyleSheet } from 'react-native';

import { Box, withTypography } from 'components/ui';
import { t } from 'state/intl/translations';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { primitive, spacing } from 'styles/constants';
const NYCRegulatoryLink: FC<React.PropsWithChildren> = () => {
  const { store } = useStore();
  const nycRegulatoryLinkAddress = useFlag(LaunchDarklyFlag.NYC_REGULATORY_LINK);

  const handleLinkPress = () => {
    Linking.openURL(nycRegulatoryLinkAddress ?? '');
  };

  if (!store?.physicalAddress || !nycRegulatoryLinkAddress) {
    return null;
  }

  return (
    <Box style={styles.badgeContainer}>
      <Icon
        accessibilityHidden
        title="Store"
        variant="store"
        size="xs"
        color={primitive.$blackOpacity50}
      />
      <StyledText>
        <StyledText bold style={styles.restaurantLabel}>{`${t(
          'restaurant',
          'Restaurant'
        )}: `}</StyledText>
        {store.physicalAddress.address1}
        {' - '}
        <StyledLink underline onPress={handleLinkPress}>
          {t('nycRestaurantHealthRatings')}
        </StyledLink>
      </StyledText>
    </Box>
  );
};

const styles = StyleSheet.create({
  badgeContainer: {
    alignSelf: 'flex-start',
    flexDirection: 'row',
    borderRadius: 5,
    paddingTop: spacing.$1,
    paddingBottom: spacing.$1,
    paddingLeft: spacing.$2,
    paddingRight: spacing.$2,
    marginBottom: spacing.$6,
    backgroundColor: primitive.$blackOpacity4,
  },
  restaurantLabel: {
    textTransform: 'capitalize',
  },
});

const StyledText = withTypography({
  variant: 'bodyOne',
  fontSize: '2xs',
  color: primitive.$blackOpacity50,
  style: {
    marginLeft: spacing.$1,
  },
});

const StyledLink = withTypography({
  variant: 'bodyOne',
  fontSize: '2xs',
  color: primitive.$blackOpacity50,
  style: {
    marginLeft: spacing.$0,
  },
});

export default NYCRegulatoryLink;
